import { render } from "./FundoPerfil.vue?vue&type=template&id=385496ae&scoped=true"
import script from "./FundoPerfil.vue?vue&type=script&lang=js"
export * from "./FundoPerfil.vue?vue&type=script&lang=js"

import "./FundoPerfil.vue?vue&type=style&index=0&id=385496ae&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385496ae"]])

export default __exports__